import {
  CustomerAddress,
  CustomerDeliveryAddress,
  CustomerUserDetails,
  OrderDelivery,
} from '@ancon/wildcat-types'
import getFullName from '@ancon/wildcat-utils/user/getFullName'

export default function getCheckoutDeliveryDetails(
  customerDeliveryAddress?: CustomerDeliveryAddress,
  customerDeliveryNote?: string,
  customerDetails?: CustomerUserDetails | null,
): OrderDelivery | undefined {
  if (customerDeliveryAddress) {
    const customerAddress = {
      ...customerDeliveryAddress,
      note: customerDeliveryNote || '',
    } as CustomerAddress

    return {
      address: customerAddress || null,
      phone: customerDetails?.telephoneNumber || '',
      recipient: getFullName(customerDetails) || '',
    }
  }

  return undefined
}
